import { QueryFunction, QueryKey, useQuery, UseQueryOptions } from 'react-query'

// This is helpful to access the queryKey from the query hook since we are generally
// separating queries into their own files.
export default function useQueryWithKey<TReturn = unknown>(
  queryKey: QueryKey,
  queryFn: QueryFunction<TReturn>,
  options?: Omit<
    UseQueryOptions<TReturn, unknown, TReturn, QueryKey>,
    'queryKey' | 'queryFn'
  >
) {
  return {
    ...useQuery(queryKey, queryFn, options),
    queryKey,
  }
}
